export default __webpack_public_path__ + "static/media/male.a4da26ff.png";